<ngx-loading-bar [value]="(delayedProgress$ | async) || 0"></ngx-loading-bar>

<portal-container>
  <router-outlet></router-outlet>
</portal-container>
